import styled, { css } from 'styled-components';
import Link from 'next/link';
import { FlexBetween } from '../../../../styled/common';
import { Breakpoints } from '../../../../styled/constants';
import { Typography } from '../../../ui/Typography';
import { SelectContainer } from '../../../ui/Select/styled';
import { SelectedValueContainer } from '../../../NewSearch/NewSearchBar/SortingFilter/styled';
import { PlaceholderBlock } from '../../../../styled/placeholders.styled';

export const ResultBlockContainer = styled(FlexBetween)`
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  margin: 0 auto 20px;
  position: relative;
  width: 100%;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    margin-bottom: 30px;
  }
`;

export const TitleContainer = styled(FlexBetween)`
  margin-bottom: 20px;
  width: 100%;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    ${SelectContainer} {
      width: 255px;
    }

    ${SelectedValueContainer} {
      justify-content: flex-start;
      font-size: 15px;
      gap: 2px;
    }
  }
`;

export const ResultBlockTitle = styled(Typography)`
  margin-top: 0;
`;

export const buttonStyles = css`
  > span {
    border: none;
  }
`;

export const ShowAllAdsText = styled(Typography)`
  padding-bottom: 1px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.text.primary};
  transition:
    color 0.3s ease,
    border-color 0.3s ease;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.colors.systemColors.blue};
      border-color: ${({ theme }) => theme.colors.systemColors.blue};
    }
  }
`;

export const ShowAllAdsLink = styled(Link)<{ $isButton: boolean }>`
  text-decoration: none;

  ${({ $isButton }) =>
    $isButton &&
    css`
      display: block;
      width: 100%;
    `}
`;

export const PlaceholderWrapper = styled.div`
  width: 100%;
`;

export const TitlePlaceholder = styled(PlaceholderBlock)`
  @media screen and (min-width: ${Breakpoints.tablet}px) {
    width: 200px;
  }
`;

export const LinkPlaceholder = styled(PlaceholderBlock)`
  display: none;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    display: block;
  }
`;
